(function ($) {
    $.fn.bootstrapSwitchPill = function (config) {
        config = $.extend({
            onText: '&nbsp;',
            offText: '&nbsp;',
            onColor: '#5cb85c',
            offColor: '#d9534f'
        }, config || {});

        var onInit = config.onInit || $.noop,
            onSwitchChange = config.onSwitchChange || $.noop;

        config.onInit = function (evt, state) {
            $(this).closest('.bootstrap-switch-wrapper').addClass('pull-right bootstrap-switch-pill');

            config.onSwitchChange.call(this, evt, state, true);
            onInit.apply(this, arguments);
        };

        config.onSwitchChange = function (evt, state, isInit) {
            var $this = $(this)
                , state = state !== undefined ? state : $this.val();

            $this.parent().css('background', state ? config.onColor : config.offColor);

            if (!isInit) {
                onSwitchChange.apply(this, arguments);
            }
        };

        return this.bootstrapSwitch(config);
    }
})(jQuery);